import script from "./VatTuDetailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VatTuDetailModal.vue?vue&type=script&lang=ts&setup=true"

import "./VatTuDetailModal.vue?vue&type=style&index=0&id=66433a7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66433a7e"]])

export default __exports__